"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHttpLink = void 0;
var client_1 = require("@apollo/client");
var utils_1 = require("../utils");
var createHttpLink = function (employeeId, currentStage, region) {
    return new client_1.HttpLink({
        uri: (0, utils_1.getGqlUrl)(currentStage, region, employeeId),
        credentials: (0, utils_1.getCredentials)(currentStage)
    });
};
exports.createHttpLink = createHttpLink;
